import styled from "styled-components";
//background: radial-gradient(circle, rgba(83,64,240,1) 52%, rgba(83,64,240,0.8158613787311799) 100%);
//background-attachment:fixed;
export const BackgroundContainer = styled("section")`



  
  overflow-x: hidden;


`;

